import { useAtomValue } from 'jotai'

import type { Navigation } from '@twisto/api-cms'
import { useBreakpoint, useOpen } from '@twisto/hooks'

import { Modal } from '../modal'
import { navigationThemeAtom } from '../navigation-theme'
import { NestedLinksProvider } from '../nested-links-provider'

import { SecondaryComponents } from './components/secondary-components'
import { Hamburger } from './hamburger'
import * as styles from './secondary-navigation-slot.styles'

type Props = {
  primaryNavigationContent: Navigation['primary']
  secondaryNavigationContent: Navigation['secondary']
}
export const SecondaryNavigationSlot = ({
  primaryNavigationContent,
  secondaryNavigationContent,
}: Props) => {
  const tabletUp = useBreakpoint('lgUp')
  const { isOpen, handleOpen, handleClose } = useOpen()
  const navigationTheme = useAtomValue(navigationThemeAtom)

  return (
    <ul css={styles.secondaryContainer}>
      <SecondaryComponents
        hideOnMobile={true}
        secondaryNavigationContent={secondaryNavigationContent}
      />
      {!tabletUp && (
        <>
          <Hamburger
            inverted={navigationTheme === 'dark'}
            opened={isOpen}
            onClick={isOpen ? handleClose : handleOpen}
          />
          <NestedLinksProvider>
            <Modal
              opened={isOpen}
              primaryComponents={primaryNavigationContent}
              secondaryComponents={secondaryNavigationContent}
              onClose={handleClose}
            />
          </NestedLinksProvider>
        </>
      )}
    </ul>
  )
}
